import { BRAND_COLORS, STATUS_COLORS } from "../lib/bookingStatus";
/**
 * MessageBadge — rote Flagge mit weißer Zahl. Feb 2026 · zeigt ungelesene
 * Nachrichten auf jedem Nachrichten-Icon in der App (Kunden-Bottom-Nav,
 * Kunden-Dashboard-Kachel, Team-Header, Team-Kundenliste).
 *
 * Der Badge liegt absolute positioniert am oberen rechten Rand der
 * umgebenden `relative`-Box. Ab 99 wird auf „99+" gekappt.
 */
export function MessageBadge({ count, testid, small = false, inline = false }) {
  const n = Number(count) || 0;
  if (n <= 0) return null;
  const label = n > 99 ? "99+" : String(n);
  if (inline) {
    return (
      <span
        data-testid={testid}
        className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 text-[10px] font-bold rounded-full leading-none shadow-sm ml-1.5"
        style={{ background: STATUS_COLORS.red, color: BRAND_COLORS.white }}
        aria-label={`${n} ungelesene Nachrichten`}
      >
        {label}
      </span>
    );
  }
  const size = small
    ? "min-w-[16px] h-[16px] text-[9.5px] -top-1 -right-1"
    : "min-w-[18px] h-[18px] text-[10.5px] -top-1.5 -right-1.5";
  return (
    <span
      data-testid={testid}
      className={`absolute ${size} px-1 rounded-full font-bold flex items-center justify-center leading-none pointer-events-none`}
      style={{
        background: STATUS_COLORS.red,
        color: BRAND_COLORS.white,
        boxShadow: "0 1px 3px rgba(0,0,0,0.25), 0 0 0 1.5px #FFFFFF",
      }}
      aria-label={`${n} ungelesene Nachrichten`}
    >
      {label}
    </span>
  );
}

export default MessageBadge;
